import React, { Component } from 'react'
import Autocomplete from '../autocomplete'
import { initGA, event } from '../analytics'
import Select, { components } from 'react-select'

const baseAcademyEndpoint = '/api/v1/academies/list.json'

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      {props.selectProps.menuIsOpen ? (
        <i className="fa fa-caret-up" aria-hidden="true"></i>
      ) : (
        <i className="fa fa-caret-down" aria-hidden="true"></i>
      )}
    </components.DropdownIndicator>
  )
}

class Filter extends Component {
  constructor(props) {
    super(props)

    this.beltOptions = [
      'black-1',
      'black',
      'black-2',
      'black-3',
      'black-4',
      'black-5',
      'black-6',
      'red-and-black',
      'red-and-white',
      'red-9',
      'red-10',
    ].map((belt) => ({
      value: belt,
      label: props.i18n.t(`certifiedBlackBelts.belts.${belt}`),
    }))
  }
  customSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? '#f7f7f7' : 'white',
      color: state.isSelected ? '#333' : null,
    }),
    indicatorSeparator: () => {},
  }

  componentDidMount() {
    initGA()
  }

  updateFilterField(e) {
    this.props.updateFilterField(e)
    this.sendGAEvent(e.target)
  }

  sendGAEvent(target) {
    const eventsCategory = 'Certified Black Belts'
    switch (target.name) {
      case 'name':
        if (target.value.length >= 3) {
          event(eventsCategory, 'Athlete Name Search', target.value)
        }
        break
      case 'belt':
        event(
          eventsCategory,
          'Belt Degree Search',
          this.findLabel(this.beltOptions, target.value)
        )
        break
      case 'academyId':
        console.log(target.label)
        event(eventsCategory, 'Academy Search', target.label)
        break
      default:
        break
    }
  }

  findLabel(options, value) {
    if (!value) {
      return
    }

    return options.find((e) => e.value === value).label
  }

  render() {
    return (
      <section className="row filters">
        <div className="col-sm-12 col-md-12 col-lg-4">
          <input
            type="text"
            name="name"
            id="athlete-name"
            placeholder={this.props.i18n.t(
              'certifiedBlackBelts.filter.searchByName'
            )}
            value={this.props.name}
            onChange={(e) => this.updateFilterField(e)}
          />

          {/* Below the minimum the name is ignored and the full list shows, which
              otherwise reads as a broken filter. */}
          {this.props.showNameMinLengthHint && (
            <small className="name-min-length-hint">
              {this.props.i18n.t('certifiedBlackBelts.filter.nameMinLength', {
                count: this.props.minNameLength,
              })}
            </small>
          )}
        </div>

        <div className="col-sm-12 col-md-12 col-lg-4">
          <Select
            options={this.beltOptions}
            id="belt-degree"
            isClearable={true}
            placeholder={this.props.i18n.t(
              'certifiedBlackBelts.filter.chooseBeltDegree'
            )}
            styles={this.customSelectStyles}
            components={{ DropdownIndicator }}
            onChange={(selected) => {
              let newValue = undefined

              if (selected) {
                newValue = selected.value
              }

              this.updateFilterField({
                target: { name: 'belt', value: newValue },
              })
            }}
          />
        </div>

        <div className="col-sm-12 col-md-12 col-lg-4">
          <Autocomplete
            endpoint={baseAcademyEndpoint}
            domain="academies"
            stateField="academyId"
            updateFilterField={(e) => this.updateFilterField(e)}
            placeholder={this.props.i18n.t(
              'certifiedBlackBelts.filter.academy'
            )}
          />
        </div>
      </section>
    )
  }
}

export default Filter
